export const OrderStatusEnum = Object.freeze({
    RECEIVED_IN_US_WAREHOUSE: 'RECEIVED IN US WAREHOUSE',
    AIR_SHIPPED_FROM_US: 'AIR SHIPPED FROM US',
    RECEIVED_IN_TBILISI_WAREHOUSE: 'RECEIVED IN TBILISI WAREHOUSE',
    SEND_TO_REGION: 'SEND TO REGION',
    OUT_FOR_DELIVERY: 'OUT FOR DELIVERY',
    FAILED_DELIVERY: 'FAILED DELIVERY',
    DELIVERED: 'DELIVERED',
});